import React from "react";
import Page from "components/Page";
import { Props } from "./PrincipleUsers";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const PrincipleUsers = lazyWithRetry(() => import("./PrincipleUsers"));

export default (props: Props) => (
  <Page>
    <PrincipleUsers {...props} />
  </Page>
);
